module.exports = __webpack_public_path__ + "static/media/rebate-modal.3af1da97.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/liveroom/rebate-modal.png
// module id = 1961
// module chunks = 6